import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'linaria';
import { containerMaxWidth, breakpointTinyTablet, breakpointLargeHandset } from 'common/constants';
const pageContainerStyle = "p16bck5y";
/**
 * Standard layout component for containing content within a page. Provides a
 * centered container with a max-width as well as standard horizontal and vertical
 * padding with mobile breakpoints. The standard use is to wrap content below the
 * global nav and above the global footer.
 *
 */

export const PageContainer = ({
  children,
  className
}) => {
  return <div className={`${pageContainerStyle} ${className}`}>{children}</div>;
};
PageContainer.propTypes = {
  /**
   * The content of the page/section.
   */
  children: PropTypes.node,

  /**
   * If you need to customize vertical or horizontal padding, pass in a CSS class
   * name to provide overriding styles. Note that we support several mobile breakpoints
   * with this component.
   */
  className: PropTypes.string
};
PageContainer.defaultProps = {
  children: null,
  className: ''
};

require("./page-container.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./page-container.js");